import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  getArticleActionReport,
  getTableColumnNames,
  getLawDocuments
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Article Action Report
export const fetchArticleActionReport = createAsyncThunk(
  "articleActionReport/fetch",
  async (articleReport, { rejectWithValue }) => {
    try {
      const response = await getArticleActionReport(articleReport);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching human categories");
    }
  }
);

// Fetch Article Action Report Table Column Names
export const fetchArticleActionReportTableColumnNames = createAsyncThunk(
  "articleActionReport/fetchArticleActionReportTableColumnNames",
  async (articleReport, thunkAPI) => {
    try {
      const response = await getTableColumnNames(articleReport);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Fetch Article Action Report Table Column Names
export const fetchArticleTableColumnNames = createAsyncThunk(
  "articleActionReport/fetchArticle",
  async (articleReport, { rejectWithValue }) => {
    try {
      const response = await getTableColumnNames(articleReport);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching human categories");
    }
  }
);

export const fetchLawDocuments = createAsyncThunk(
  "articleActionReport/fetchLawDocuments",
  async (articleReport, { rejectWithValue }) => {
    try {
      const response = await getLawDocuments(articleReport);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching human categories");
    }
  }
);